import React from 'react';
import { Input } from 'antd';

type Props = {
  value: string,
  onChange: (text: string) => void,
  onBlur: () => void,
  placeholder: string,
  customValidator?: (text: string) => string,
};

export default function StringInput(props: Props) {
  const { value, onBlur, onChange, placeholder, customValidator } = props;
  const errorMessage = customValidator && customValidator(value);
  return (
    <>
      <Input
        className={errorMessage ? 'error' : ''}
        placeholder={placeholder}
        value={value}
        onBlur={onBlur}
        onChange={onChange}
      />
      {errorMessage && <div className="error-message">{errorMessage}</div>}
    </>
  );
}
